import { computed, Injectable, signal } from '@angular/core';
import { PaginationResponse } from '@iq-central-front-end/share';

export interface CourseState {
    courses: PaginationResponse<any> | null;
    courseLessons: any[] | null;
    course: any;
    loading: boolean;
    error: string | null;
    dueCourses: any;
    enrolledCourses: PaginationResponse<any> | null;
}

@Injectable({ providedIn: 'root' })
export class CourseStore {
    private readonly state = signal<CourseState>({
        courses: null,
        courseLessons: null,
        course: null,
        loading: false,
        error: null,
        dueCourses: null,
        enrolledCourses: null,
    });

    readonly courses$ = computed(() => this.state().courses);
    readonly courseLessons$ = computed(() => this.state().courses?.data);
    readonly course$ = computed(() => this.state().course);
    readonly loading$ = computed(() => this.state().loading);
    readonly error$ = computed(() => this.state().error);
    readonly dueCourses$ = computed(() => this.state().dueCourses);
    readonly enrolledCourses$ = computed(() => this.state().enrolledCourses);

    setLoading(loading: boolean): void {
        this.state.update((state) => ({ ...state, loading }));
    }

    setError(error: string | null): void {
        this.state.update((state) => ({ ...state, error }));
    }

    setCourses(courses: PaginationResponse<any>): void {
        this.state.update((state) => ({ ...state, courses, loading: false }));
    }

    setCourseLessons(courseLessons: any[]): void {
        this.state.update((state) => ({ ...state, courseLessons }));
    }

    setCourse(course: any): void {
        this.state.update((state) => ({
            ...state,
            course,
            loading: false,
        }));
    }

    setDueCourses(dueCourses: any): void {
        this.state.update((state) => ({ ...state, dueCourses }));
    }

    setEnrolledCourses(enrolledCourses: PaginationResponse<any>): void {
        this.state.update((state) => ({ ...state, enrolledCourses }));
    }
}
